import { MouseEvent, useEffect } from "react";

function useOutsideClick(ref: any, onOutsideClick: (event: MouseEvent) => void, unbindListener = false) {
  useEffect(() => {
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside, { passive: true });

    // Unbinding of listener is necessary so that outside click is not triggered on every click
    if (unbindListener) {
      // Unbind the event listener if not needed
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, unbindListener]);

  function handleClickOutside(event: MouseEvent) {
    if (ref.current && !ref.current.contains(event.target)) {
      onOutsideClick(event);
    }
  }
}

export default useOutsideClick;
